import { AccordionForm, AccordionFormPanelProps as Props } from '@react-admin/ra-form-layout';
import { ReactElement } from 'react';
import JsonApiHasOneReferenceInput from '../../../Components/JsonApiHasOneReferenceInput';
import { BidResource } from '../../../Entities/Bid';

export default function GetPriceDetailsSection(props: Omit<Props, 'children'>): ReactElement {
  return (
    <AccordionForm.Panel {...props}>
      <JsonApiHasOneReferenceInput<BidResource, 'category', 'categories'>
        label="Category"
        nullable={false}
        optionText="attributes.full_name"
        reference="categories"
        source="relationships.category"
      />
      <JsonApiHasOneReferenceInput<BidResource, 'product', 'products'>
        label="Product"
        optionText="attributes.name"
        reference="products"
        source="relationships.product"
      />
    </AccordionForm.Panel>
  );
}
